import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UsuarioGerenteMultiselectComponent } from './usuario-gerente-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UsuarioGerenteMultiselectComponent
    ],
    exports: [
        UsuarioGerenteMultiselectComponent
    ]
})
export class UsuarioGerenteMultiselectModule { }
